// src/customerlogins/components/CustomerNavbar.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

function CustomerNavbar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/customer-login');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-success px-3">
      <span className="navbar-brand">Customer Panel</span>
      <div className="ms-auto">
        <button className="btn btn-outline-light btn-sm" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </nav>
  );
}

export default CustomerNavbar;
